import React from "react";
import {
    CircularProgress,
    CircularProgressProps,
    InternalStandardProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

interface StyledCircularProgressProps extends CircularProgressProps {
    notPrimary?: boolean;
}

const StyledCircularProgress = styled(CircularProgress, {
    shouldForwardProp: (prop) => prop !== "notPrimary",
})<StyledCircularProgressProps>(({ theme, notPrimary }) => ({
    color: notPrimary ? theme.colors.white : theme.palette.primary.main,
}));

export interface AppCircularProgressProps
    extends InternalStandardProps<CircularProgressProps> {
    loaderSize?: "small";
    notPrimary?: boolean;
}

export const AppCircularProgress = (props: AppCircularProgressProps) => {
    const { className, loaderSize, notPrimary, ...rest } = props;

    return (
        <StyledCircularProgress
            {...rest}
            className={className}
            notPrimary={notPrimary}
            size={loaderSize === "small" ? 20 : 40}
        />
    );
};
